module.exports = __webpack_public_path__ + "img/framboise_namelaka_cooked_closeup.94c868dc.jpg";